<template>
  <v-container class="px-6">
    <h1>Pagamentos publicados
      <span>
                    <v-tooltip right>
                      <template v-slot:activator="{on, attrs}">
                        <v-btn
                          color="primary"
                          icon
                          small
                          @click=modalVideo()
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon small>fa-regular fa-life-ring</v-icon>
                        </v-btn>
                      </template>
                        <span class="px-3 py-1 ma-0"
                          style="
                          border: solid 1px #999;
                          border-radius: 5px;
                          background-color: #fff;
                          ">Acompanhe dados conciliados e detalhes do pagamento</span>
                        </v-tooltip>
                  </span>
    </h1>
    <p>Controle aqui a baixa dos pagamentos publicados.</p>
        <PgtosPublicadosFilter
      :filterList="(formData) => filterList(formData, 1)"
      :mesCorrente="mesCorrente"
      :orderr="order"
      :sortt="sort"
    />
    <PgtosPublicadosList
      :pagamentos="pagamentos"
      :lotes="lotes"
      :lotesPagination="lotesPagination"
      :pagination="pagination"
      :filterData="filter"
      :filterList="(filterData, page) => filterList(filterData, page)"
      :getLotesPagamento="(pagto_id, options)=> getLotesPagamento(pagto_id, options)"

    />

  </v-container>
</template>

<script>
import { mapState } from "vuex"
import PgtosPublicadosFilter from './pagamentos_publicados/Filter'
import PgtosPublicadosList from './pagamentos_publicados/List'

export default {
  components: {
    PgtosPublicadosFilter,
    PgtosPublicadosList,
  },
  data() {
    return{

      sort: null,
      order: null,
      filter: null,
      pagamentos: null,
      pagamentoId: null,
      lotes: null,
      lotesPagination:{
          order: null,
          sort: null,
          limit: 20,
          offset: 0,
          total: 0,
          total_pages: 1
      },
      pagination:{
        limit: 20,
        offset: 1,
        total: 0,
        total_pages: 1
      },
      mesCorrente: {
        dt_inicio: null,
        dt_fim: null
      }
    }
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
    }),
  },

  methods: {
    async filterList(formData, page){

      this.order = formData["order"]
      this.sort = formData["sort"]

      if (formData.powerFilter) { // powerfilter - reset do filtro
        this.pagamentos = null
        this.saveFilter(formData)
        return
      }
      this.pagination.offset = page? page : 1
      let obj = {
        query: [
          {
            Modulo: "Recebiveis",
            Acao: "getpagamentospublicados",
            Payload: { ...formData, ...this.pagination}
          },
        ],
      }
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader")
          return
        }
        this.mesCorrente.dt_inicio = response.dt_inicio.split('T')[0]
        this.mesCorrente.dt_fim = response.dt_fim.split('T')[0]
        this.pagamentos = response
        this.pagination.offset = response.current_page == 0 ?1 :response.current_page
        this.pagination.total_pages = response.total_pages
        this.saveFilter(formData)
      })
    },
      modalVideo(){
      let paramModal = {
          codigo: "754810157",
          title: "Acompanhe dados conciliados e detalhes do pagamento",
      }
      this.$store.commit('tutorial/abreVideo', paramModal);
    },


    getLotesPagamento(pagamento_id, options) {
      if(this.pagamentoId != pagamento_id ){
        this.lotesPagination =
        {
          order: null,
          sort: null,
          limit: 10,
          offset: 0,
          total: 0,
          total_pages: 1
        }
      }
      this.pagamentoId = pagamento_id
      this.lotesPagination = Object.assign(this.lotesPagination, options)
      let { grupo_economico } = this.filter
      let obj = {
        query: [
          {
            Modulo: "Recebiveis",
            Acao: "getlotespagamento",
            Payload: { grupo_economico, pagamento_id, ...this.lotesPagination }
          },
        ],
      }
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader")
          return
        }
        this.lotes = response
        this.lotesPagination.offset = response.current_page
        this.lotesPagination.total = response.total
        this.lotesPagination.total_pages = response.total_pages
      })
    },
    // showOpen(item) {
    //   // this.dialog = true
    //   let obj = {
    //     prestador_id: [item.prestador_id],
    //     operadora_ans_id: [item.operadora_ans_id],
    //     logins: item.logins,
    //   }
    //   this.historico = obj
    // },
    saveFilter(filter){
      this.filter = filter
      this.filter.grupo_economico = this.grupoEconomico

      let opts = {
          filterData: {
            grupo_economico: this.grupoEconomico,
            ...filter
          },
          filterName: 'pagamentosPublicados',
          redirect: false
        }
        this.$store.commit('recebiveis/setFilter', opts, { root:true })
    },
  }
}
</script>

<style>

</style>
